import { Flex } from '@chakra-ui/react'

import CAAMetricsCards from './components/CAAMetricsCards'
import CAAMetricsFilter from './components/CAAMetricsFilter'
import CAAMetricsPeriod from './components/CAAMetricsPeriod'
import CAAMetricsTable from './components/CAAMetricsTable'

export default function CAAMetrics() {
  return (
    <Flex flexDir={'column'} gap={'5'}>
      <CAAMetricsPeriod />
      <CAAMetricsFilter />
      <CAAMetricsCards />
      <CAAMetricsTable />
    </Flex>
  )
}
